import { render, staticRenderFns } from "./NomeResponsavel.vue?vue&type=template&id=7ffa6916&"
import script from "./NomeResponsavel.vue?vue&type=script&lang=js&"
export * from "./NomeResponsavel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports